import comp from "./AITutorChatResetButton";
export default comp;
